import { render, staticRenderFns } from "./FontRange.vue?vue&type=template&id=88c4d40e&scoped=true&"
import script from "./FontRange.vue?vue&type=script&lang=ts&"
export * from "./FontRange.vue?vue&type=script&lang=ts&"
import style0 from "./FontRange.vue?vue&type=style&index=0&id=88c4d40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c4d40e",
  null
  
)

export default component.exports